import React, { useState, useContext, useCallback } from 'react';

import { InjectedIntl, injectIntl } from 'react-intl';

import { Profile } from '@atlaskit/atlassian-navigation';
import Avatar from '@atlaskit/avatar';
import { Popup } from '@atlaskit/popup';

import AccountMenu from '../account-menu';
import messages from '../account-menu.i18n';
import { ThemeSelectorFeedbackSuccessFlag } from '../theme-selector/theme-selector-feedback';

import { HorizontalNavContext } from './horizontal-nav-context';

type Props = {
  intl: InjectedIntl;
};

const HorizontalProfilePopup: React.FC<Props> = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFlag, setIsFlag] = useState(false);
  const { avatarUrl } = useContext(HorizontalNavContext);

  const onClick = () => {
    setIsOpen(!isOpen);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const accountMenuProps = useContext(HorizontalNavContext);

  const tooltip = accountMenuProps.isLoggedIn
    ? messages.loggedInUserTooltip
    : messages.anonymousUserTooltip;

  const popupContent = useCallback(() => {
    const themeSelectorProps = {
      onThemeSelect: onClose,
      onThemeFeebackSubmit: () => setIsFlag(true),
    };

    return (
      <AccountMenu
        {...accountMenuProps}
        themeSelectorProps={themeSelectorProps}
      />
    );
  }, [accountMenuProps]);

  return (
    <>
      <Popup
        placement="bottom-start"
        content={popupContent}
        isOpen={isOpen}
        onClose={onClose}
        trigger={triggerProps => (
          <Profile
            icon={<Avatar size="small" src={avatarUrl} />}
            onClick={onClick}
            isSelected={isOpen}
            tooltip={props.intl.formatMessage(tooltip)}
            testId="profile-button"
            {...triggerProps}
          />
        )}
      />
      {isFlag && (
        <ThemeSelectorFeedbackSuccessFlag
          intl={props.intl}
          onClose={() => setIsFlag(false)}
        />
      )}
    </>
  );
};

export default React.memo(injectIntl(HorizontalProfilePopup));
